import { Component, Input, OnInit, inject } from '@angular/core';
import { DeviceService, MobilePlatform } from '../../../services/device.service';

const DISMISS_KEY = 'atc_appBannerDismissed';

/**
 * Small dismissible "Open in the App" banner for public /links/* pages
 * (group invite, event invite, ...). Only renders on iOS/Android. Tapping
 * "Open" tries to hand off straight to the native app (which, if installed,
 * lands on the same deep-linked screen this page represents); if the app
 * isn't installed it falls through to the appropriate app store.
 *
 * This is deliberately non-blocking - the web flow underneath keeps working
 * for anyone who ignores or dismisses the banner.
 */
@Component({
  selector: 'app-open-banner',
  standalone: true,
  imports: [],
  templateUrl: './app-open-banner.component.html',
  styleUrl: './app-open-banner.component.css',
})
export class AppOpenBannerComponent implements OnInit {
  /** Path (relative to the web app domain, no leading slash) to deep link
   *  into, e.g. `links/groupinvite?groupId=abc123`. Falls back to the
   *  current page path if not provided. */
  @Input() path: string | null = null;

  platform: MobilePlatform = 'other';
  dismissed = false;

  private device = inject(DeviceService);

  ngOnInit(): void {
    this.platform = this.device.getMobilePlatform();
    if (typeof sessionStorage !== 'undefined') {
      this.dismissed = sessionStorage.getItem(DISMISS_KEY) === 'true';
    }
  }

  get show(): boolean {
    return !this.dismissed && this.platform !== 'other';
  }

  dismiss(): void {
    this.dismissed = true;
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem(DISMISS_KEY, 'true');
    }
  }

  openApp(): void {
    this.device.openApp(this.path ?? this.device.currentPath());
  }
}
